import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-1095">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-1096">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-1097">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-1098">
          {isOpen ? <XIcon size={24} data-id="element-1099" /> : <PlusIcon size={24} data-id="element-1100" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-1101">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-1102">
          {answer}
        </p>
      </div>
    </div>;
}
export function FDFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'What Are The Most Common Side Effects Of Kybella?',
    answer: 'KYBELLA earned FDA-approval in 2015 and has been used successfully for many years. The most common side effects of KYBELLA include pain, swelling, bruising, redness, and numbness, but most side effects subside in 1-2 weeks.'
  }, {
    question: 'How Do These Injectables Work?',
    answer: 'Fat-dissolving injectables work by using a specialized solution, often containing deoxycholic acid, to break down and destroy fat cells in targeted areas. Once the solution is injected, it disrupts the fat cell membranes, causing the cells to break apart and be naturally eliminated by the body over time.'
  }, {
    question: 'How Long Does It Take To See Results?',
    answer: 'Results are often noticeable within 24-48 hours after the treatment. However, the full effect may take up to a week as the filler continues to break down and swelling subsides. Multiple sessions may be needed for optimal results depending on the amount of filler being dissolved.'
  }, {
    question: 'Do Fat Dissolving Injections Help Loose Skin?',
    answer: 'Fat-dissolving injections are designed to target and destroy fat cells, but they do not address loose or sagging skin. For individuals with loose skin, additional treatments such as skin-tightening procedures may be recommended alongside or after fat-dissolving injections to achieve a smoother, firmer appearance.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1103">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1104">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1105">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1106">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1107"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-1108">
          <div className="space-y-2" data-id="element-1109">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-1110" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}